module.exports = __webpack_public_path__ + "img/sa.e9b568d8.svg";